<!-- @veltra/icons generated sha256:08cd7d72ba44720b gen:8 source:src/svg/normal/poweroff.svg -->
<script setup lang="ts">
defineOptions({ name: 'Poweroff' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M7.5 7.491V1.51A.51.51 0 0 1 7.996 1a.51.51 0 0 1 .504.509V7.49a.51.51 0 0 1-.496.51.51.51 0 0 1-.504-.509m-2.951-4.5a6.5 6.5 0 1 0 6.903 0 .476.476 0 0 0-.661.175l-.002.003c-.142.246-.043.556.195.71a5.5 5.5 0 1 1-5.968 0c.238-.154.337-.464.195-.71l-.002-.003a.476.476 0 0 0-.66-.175"
    />
  </svg>
</template>
